import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import TopBar from '../../../components/TopBar';
import DraftDocumentListPageActions from '../../draftDocuments/components/DraftDocumentListPageActions';
import { useSelector } from 'react-redux';
import FeatureNotSupportedDialog from '../../common/FeatureNotSupportedDialog';
import SBDraftInvoiceListPage from './SBDraftInvoiceListPage';
import SBDraftCreditNoteListPage from './SBDraftCreditNoteListPage';
import SBDraftDebitNoteListPage from './SBDraftDebitNoteListPage';
import SBDraftRefundListPage from './SBDraftRefundsListPage';

const tabs = [
  { key: 'invoices', label: 'Invoices' },
  { key: 'creditNotes', label: 'Credit Notes' },
  { key: 'debitNotes', label: 'Debit Notes' },
  { key: 'refunds', label: 'Refunds' },
];

const filters = [{ key: 'document_number', label: 'Document Number' }];

const SBDraftDocumentListPage = () => {
  const location = useLocation();
  const user = useSelector((state) => state.org.org.user);
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get('tab') || 'invoices';
  const subscription = useSelector((state) => state.org.org.subscription);

  const [selectedTab, setSelectedTab] = useState(initialTab);

  useEffect(() => {
    setSelectedTab(initialTab);
  }, [initialTab]);

  return subscription?.features?.enable_consolidation ? (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Staged for Consolidation">
        {user?.permissions?.documents === 2 && <DraftDocumentListPageActions onCloseUrl={'/self-billed-drafts'} />}
      </TopBar>
      {selectedTab === 'invoices' && <SBDraftInvoiceListPage />}
      {selectedTab === 'creditNotes' && <SBDraftCreditNoteListPage />}
      {selectedTab === 'debitNotes' && <SBDraftDebitNoteListPage />}
      {selectedTab === 'refunds' && <SBDraftRefundListPage />}
    </Stack>
  ) : (
    <FeatureNotSupportedDialog
      title={'E-Invoice Consolidation'}
      description={'Upload/create receipts and automatically generate consolidated documents.'}
    />
  );
};

export default SBDraftDocumentListPage;
